import { render, staticRenderFns } from "./SalesInvoices.vue?vue&type=template&id=7a6e6bc4&scoped=true"
import script from "./SalesInvoices.vue?vue&type=script&lang=js"
export * from "./SalesInvoices.vue?vue&type=script&lang=js"
import style0 from "./SalesInvoices.vue?vue&type=style&index=0&id=7a6e6bc4&prod&lang=scss"
import style1 from "./SalesInvoices.vue?vue&type=style&index=1&id=7a6e6bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6e6bc4",
  null
  
)

export default component.exports